import * as React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'app/pages/DiscountEditor/actionTypes';
import { DiscountActionTypeTarget, DiscountBandType, DiscountActionTargetTypeEnum } from 'app/shared/model';
import ActionTargetSelectionStep from 'app/pages/DiscountEditor/components/NewDiscountActionWizard/ActionTargetSelectionStep';
import BandTypeSelectionStep from 'app/pages/DiscountEditor/components/NewDiscountActionWizard/BandTypeSelectionStep';
import { showNewDiscountActionWizard, getSavedDiscountActions } from 'app/pages/DiscountEditor/modules/DiscountActions';
import { cancelAddOrUpdateDiscountAction } from 'app/pages/DiscountEditor/actions';
import { startAddingDiscountActionCommand } from 'app/pages/DiscountEditor/commands';

enum WizardStep {
    "ActionTargetSelection", 
    "BandTypeSelection"
}

interface StateProps {
    isOpen: boolean, 
    availableActionTargets: DiscountActionTypeTarget[] 
}

interface DispatchProps { 
    onClose: () => void, 
    onFinish: (target : DiscountActionTypeTarget, bandType: DiscountBandType) => void
}

type InternalProps = StateProps & DispatchProps;

interface InternalState {
    currentStep: WizardStep
    actionTarget?: DiscountActionTypeTarget
}

class NewDiscountActionWizard extends React.Component<InternalProps, InternalState> {
    constructor(props: InternalProps) {
        super(props);
        this.state = this.getEmptyState()
    }

    private getEmptyState() {
        return {
            currentStep: WizardStep.ActionTargetSelection,
            actionTarget: undefined           
        };
    }

    private setActionTarget(actionTarget: DiscountActionTypeTarget) {
        this.setState({
            currentStep: WizardStep.BandTypeSelection,
            actionTarget: actionTarget
        });
    }

    private setBandType(bandType: DiscountBandType) {
        if (this.state.actionTarget === undefined)
            throw new Error('discount action target must have a value')

        this.props.onFinish(this.state.actionTarget, bandType); 
    }

    componentWillReceiveProps(nextProps: InternalProps) {
        if (nextProps.isOpen && !this.props.isOpen) {
            this.setState(this.getEmptyState());
        }
    }

    render() {
        return <div>
            <ActionTargetSelectionStep 
                 actionTargets={this.props.availableActionTargets}
                 isVisible={this.props.isOpen && this.state.currentStep === WizardStep.ActionTargetSelection}
                 onSelect={(target) => this.setActionTarget(target)}
                 onCloseWizard={this.props.onClose} />

            <BandTypeSelectionStep 
                 bandTypes={DiscountBandType.AllValues}
                 isVisible={this.props.isOpen && this.state.currentStep === WizardStep.BandTypeSelection}
                 onSelect={(type) => this.setBandType(type)}
                 onCloseWizard={this.props.onClose} />            
        </div>
    }    
}

const mapStateToProps = (state:any, ownProps: {}) : StateProps => {
    const hasApplicableProductsAction = getSavedDiscountActions(state)
        .some(x => x.target.type === DiscountActionTargetTypeEnum.ApplicableProducts); 

    const availableActionTargets = hasApplicableProductsAction
        ? DiscountActionTypeTarget.AllValues.filter(x => x !== DiscountActionTypeTarget.ApplicableProducts)
        : DiscountActionTypeTarget.AllValues; 

    return {
        isOpen: showNewDiscountActionWizard(state), 
        availableActionTargets: availableActionTargets
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>) : DispatchProps => ({
    onClose: () => dispatch(cancelAddOrUpdateDiscountAction()),
    onFinish: (target : DiscountActionTypeTarget, bandType: DiscountBandType) => 
        dispatch(startAddingDiscountActionCommand(target.toEnumValue(), bandType.toEnumValue()))
});

export default connect(mapStateToProps, mapDispatchToProps)(NewDiscountActionWizard);






